export default "__VITE_ASSET__c0d6b05c__"